import { useCurrentPeriod, useIncident } from './hooks/incidentHooks';
import { useIncidentInfo } from './hooks/incidentInfoHooks';
import IAPDashboardNew from './IAPDashboardNew';
import InitialResponsePage from './initialResponsePage/InitialResponsePage';
import { useIncidentRoster } from './hooks/incidentRoster/useIncidentRoster';

const IAPDashboard = () => {
  // trigger preloaded fetches
  useIncidentRoster();
  useIncidentInfo();

  const incident = useIncident();

  const { periodNumber } = useCurrentPeriod();

  if (incident.data === undefined) {
    return null;
  }

  const isEscalated = !!incident.data.escalated_at;

  return periodNumber === 0 && !isEscalated ? (
    <InitialResponsePage />
  ) : (
    <IAPDashboardNew />
  );
};

export default IAPDashboard;
